#!/usr/bin/env node
import fs from 'fs';
import path from 'path';
import { parseApiRoutes } from '../middlewares/openapi/services';

const args = process.argv.slice(2);

function getArg(name: string, defaultValue: string): string {
  const index = args.indexOf(name);
  if (index !== -1 && args[index + 1]) {
    return args[index + 1];
  }
  return defaultValue;
}

const serverDir = path.resolve(process.cwd(), getArg('--server-dir', './server'));
const outDir = path.resolve(process.cwd(), getArg('--out-dir', './dist'));
const filename = getArg('--filename', 'api-routes.json');

try {
  const routes = parseApiRoutes(serverDir);
  if (!fs.existsSync(outDir)) {
    fs.mkdirSync(outDir, { recursive: true });
  }
  const outPath = path.resolve(outDir, filename);
  fs.writeFileSync(outPath, JSON.stringify(routes, null, 2));
  console.log(`[api-routes] Generated ${outPath} (${routes.length} routes)`);
} catch (error) {
  console.warn('[api-routes] Failed to generate api-routes.json, writing empty fallback:', error);
  if (!fs.existsSync(outDir)) {
    fs.mkdirSync(outDir, { recursive: true });
  }
  fs.writeFileSync(path.resolve(outDir, filename), JSON.stringify([], null, 2));
}
